import { blobClient } from '@api/client';
import { URL } from '@api/urls';

import { IId } from '@interfaces/common/common';

const { alarmHistory } = URL;

export const clearActiveAlarm = ({ id }: IId): Promise<void> => blobClient.post(`${alarmHistory}/${id}/clear`);
